import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

@Component({
  selector: 'app-popin',
  templateUrl: './popin.component.html',
  styleUrls: ['./popin.component.scss'],
})
export class PopinComponent {
  @HostBinding('style.display') display = 'inital';
  @Output() closeOutput = new EventEmitter<void>();

  _show = false;

  @Input() set show(_show: boolean) {
    this._show = _show;
    if (this._show) {
      this.display = 'initial';
    } else {
      this.display = 'none';
    }
  }

  catchEvent(ev: Event) {
    ev.stopPropagation();
    ev.stopImmediatePropagation();
  }

  sendClose() {
    this.closeOutput.emit();
  }
}
